module.exports = __webpack_public_path__ + "img/file-grey.27166e60.svg";